module.exports = __webpack_public_path__ + "img/Sicong_Geng.03fead2e.png";